import { useJsonForms } from "@jsonforms/react";
import { AdapterMoment } from "@mui/x-date-pickers/AdapterMoment";
import { DatePicker } from "@mui/x-date-pickers/DatePicker";
import { LocalizationProvider } from "@mui/x-date-pickers/LocalizationProvider";
import moment from "moment-timezone";
import { getStoredProgramDateFormat } from "../../../utils/commons";
import "../../common/DatePickerMaterialUI/DatePickerMaterialUI.scss";

moment.locale("en");

export default function DatePickerMaterialUIField(props) {
  const {
    value,
    updateValue,
    uiSchema,
    label,
    visible,
    placeholder,
    disabled,
    timezone,
    readOnly,
    setToEndOfDay = false,
    setToStartOfDay = false,
    disableFutureDates = false,
  } = props;

  const handleDateChange = (date) => {
    if (date) {
      let adjustedDate = date.clone();

      // If setToStartOfDay is true, set the time to 12:00 AM
      if (setToStartOfDay) {
        adjustedDate = adjustedDate.startOf("day");
      }

      // If setToEndOfDay is true, set the time to 11:59 PM
      if (setToEndOfDay) {
        adjustedDate = adjustedDate.endOf("day");
      }

      const formattedDate = adjustedDate.toISOString();
      updateValue(formattedDate);
    } else {
      updateValue(null);
    }
  };

  const ctx = useJsonForms();
  const jsonformState = ctx.core.data;

  const getMinimumAllowedDate = () => {
    if (uiSchema.minimum === "currentDateTime") {
      return moment.tz(new Date(), timezone);
    }
    return jsonformState?.[uiSchema.minimum]
      ? moment.tz(jsonformState?.[uiSchema.minimum], timezone)
      : null;
  };

  const baseMinDate = getMinimumAllowedDate();
  const minDate =
    baseMinDate && uiSchema?.minimumOffsetDays
      ? baseMinDate.clone().add(uiSchema.minimumOffsetDays, "days")
      : baseMinDate;

  // If disableFutureDates is true, set maxDate to today
  const todayDate = disableFutureDates ? moment.tz(new Date(), timezone) : null;

  const fallbackMaxDate = uiSchema?.maximum
    ? moment.tz(uiSchema.maximum, timezone)
    : todayDate;

  const maxDate = jsonformState?.[uiSchema.maximum]
    ? moment.tz(jsonformState?.[uiSchema.maximum], timezone)
    : fallbackMaxDate;

  return visible ? (
    <div className="date-picker-material-ui-wrap">
      {label && (
        <label htmlFor={`datePicker-${label}`}>
          {label}
          {props.required && (
            <span className="required-text $font-xxsmall-bold float-right">
              *Required
            </span>
          )}
        </label>
      )}
      <LocalizationProvider
        dateAdapter={AdapterMoment}
        dateLibInstance={moment}
        adapterLocale="en"
      >
        <DatePicker
          className="customDatePickerStyles"
          value={value ? moment.tz(value, timezone) : null}
          onChange={handleDateChange}
          minDate={minDate}
          maxDate={maxDate}
          label={placeholder}
          disabled={disabled}
          readOnly={readOnly}
          format={getStoredProgramDateFormat()}
          timezone={timezone}
        />
      </LocalizationProvider>
    </div>
  ) : null;
}
